import React from "react";
import { useTranslation } from "react-i18next";

import { AddHeader } from "../../components/AddHeader";
import { useLocation } from "react-router";
import { EditUser } from "../../components/AdminLayout/EditUser";

export const UpdateUser = () => {
  const location = useLocation();
  const data = location.state.info;
  const { t } = useTranslation();

  return (
    <>
      <div id="adminRoot" className="user-form-theme">
        <AddHeader title={t("edituser")} />
        <EditUser data={data} />
      </div>
    </>
  );
};
